// extracted by mini-css-extract-plugin
export default {"main":"main__eVaYy","sideBarConatiner":"sideBarConatiner__5EJ3V","mainContent":"mainContent__D+wiA"};